import {createEntityService} from 'utils/createEntityService';
import {UserEvaluation} from 'types/userEvaluation';

export const UserEvaluationService = createEntityService<UserEvaluation>({
  baseUrl: 'api/v1/user_evaluations',
  entityName: 'userEvaluation',
});
